import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {APIConfig} from '../app.constant';
import {Project} from '../models/project.model';
import {Observable} from 'rxjs/Observable';
import {HttpHeaders} from '@angular/common/http';
import {SessionService} from './session.service';

@Injectable()
export class ProjectService extends BaseService {

  getAllProjects(): Observable<Project[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get(APIConfig.API_PROJECT_ALL_URL, this.options);
  }

  getRollingProjects(): Observable<Project[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get<Project[]>(APIConfig.API_PROJECT_ROLLING_URL, this.options);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/project.service.ts